module.exports = __webpack_public_path__ + "img/1782721570233-WhatsApp Image 2026-06-29 at 16.20.53.jpeg.df7d9c3c.webp";